export class DesmonstracoesAtuariaisDaPCD {


    static desmonstracoesAtuariaisDaPCDLista: DesmonstracoesAtuariaisDaPCD[] = [
        { tipo: 'pdf', descricao: '2024', caminho: 'DA_2024_PCD.pdf' },
        { tipo: 'pdf', descricao: '2023', caminho: 'DA_2023_PCD.pdf' },
        { tipo: 'pdf', descricao: '2022', caminho: 'DA_2022_PCD.pdf' },
        { tipo: 'pdf', descricao: '2021', caminho: 'DA_2021_PCD.pdf' },
        { tipo: 'pdf', descricao: '2020', caminho: 'DAS_2020_PCD.pdf' },
        { tipo: 'pdf', descricao: '2018', caminho: 'da_2018_pcd.pdf' },
        { tipo: 'pdf', descricao: '2017', caminho: 'da_2017_pcd.pdf' },
        { tipo: 'pdf', descricao: '2016', caminho: 'da_2016_pcd.pdf' },
        { tipo: 'pdf', descricao: '2015', caminho: 'da_2015_pcd.pdf' },
        { tipo: 'pdf', descricao: '2014', caminho: 'da_2014_pcd.pdf' }
    ];

    constructor(
        public tipo: string,
        public descricao: string,
        public caminho: string
    ) {

    }




}




// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/shared/util/dados-documentos-institucional/lista-documentos/demonstracoes-atuariais-da-pcd.ts